import { GenerateBrokerageFirmReportsCard, ReportsForBrokerageFirmList } from '@folio/components';
import { useState } from 'react';

export function BrokerageFirmReports() {
  const [reportType, setReportType] = useState<string | undefined>(undefined);

  return (
    <div className="space-y-8">
      <GenerateBrokerageFirmReportsCard
        title="Générer un rapport"
        onTypeChange={type => setReportType(type)}
      />

      <ReportsForBrokerageFirmList reportType={reportType ?? ''} />
    </div>
  );
}
